import {ConfEnv} from "../../config/config";
import publicRequest from "../../Infra/http/public.request";

/**
 * Validates a national ID against the public KYC endpoint.
 */
export const identityValidateService = async payload => {
  const {data, status} = await publicRequest.post(
    ConfEnv.API_URL.URL_IDENTITY_VALIDATE,
    {
      id_type: payload.id_type,
      national_id: payload.national_id,
    },
    {"Content-Type": "application/json"}
  );

  const result = {
    status,
    data: data?.data ?? data,
  };
  return result;
};
